import React from "react";
import '../../index.css'

const Header = ({closeChatBot}) => {
  return (
    <div id="header"> 
      <p id="header-title">Welcome to MediCard Customer Support!</p>
      <span onClick={() => closeChatBot()}>
        <svg id="ChatCloseButton"  style={{ fill:"white", cursor:"pointer", marginTop:"10px",marginRight:"10px" }}xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 18 18">
            <path d="M14.53 4.53l-1.06-1.06L9 7.94 4.53 3.47 3.47 4.53 7.94 9l-4.47 4.47 1.06 1.06L9 10.06l4.47 4.47 1.06-1.06L10.06 9z"/>
        </svg>
      </span>
    </div>
  )
}

export default Header
